module.exports = __webpack_public_path__ + "img/madera020.e7c599d2.jpg";